module.exports = __webpack_public_path__ + "static/media/delivery-preference.428bc329.svg";